export enum ModalSelection {
  CONFIRMATION = 'CONFIRMATION',
  EDIT_REPR = 'EDIT_REPR',
  INFO = 'INFO',
  QUERY = 'QUERY',
}

export enum ConfirmationModalResponse {
  YES = 'MODAL/CONFIRMATION_YES',
  NO = 'MODAL/CONFIRMATION_NO',
}

export const QueryModalType = 'MODAL/QUERY'
